export const Calculator = () => {
  const color = "#10b6eb";
  return (
    <>
      <svg
        // height={50}
        // width={40}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 49.13 61.42"
      >
        <g>
          <g>
            <path
              style={{ fill: color }}
              d="m47.16,54.19c0,2.9-2.38,5.27-5.31,5.27H7.28c-2.93,0-5.31-2.36-5.31-5.27V7.22C1.97,4.32,4.35,1.96,7.28,1.96h34.57c2.93,0,5.31,2.36,5.31,5.27v46.97ZM41.85,0H7.28C3.27,0,0,3.24,0,7.22v46.97C0,58.18,3.27,61.42,7.28,61.42h34.57c4.02,0,7.28-3.24,7.28-7.22V7.22C49.13,3.24,45.87,0,41.85,0"
            />
            <path
              style={{ fill: color }}
              d="m9.06,8.94c-.91,0-1.65.73-1.65,1.63v4.66c0,.9.74,1.63,1.65,1.63h31.02c.91,0,1.64-.73,1.64-1.63v-4.66c0-.9-.74-1.63-1.64-1.63H9.06Zm31.02,9.88H9.06c-2,0-3.62-1.61-3.62-3.59v-4.66c0-1.98,1.62-3.59,3.62-3.59h31.02c1.99,0,3.62,1.61,3.62,3.59v4.66c0,1.98-1.62,3.59-3.62,3.59"
            />
            <path
              style={{ fill: color }}
              d="m18.32,23.49c-.8,0-1.46.65-1.46,1.44v3.17c0,.8.65,1.45,1.46,1.45h1.5c.8,0,1.46-.65,1.46-1.45v-3.17c0-.8-.65-1.44-1.46-1.44h-1.5Zm1.5,8.02h-1.5c-1.89,0-3.43-1.53-3.43-3.4v-3.17c0-1.88,1.54-3.4,3.43-3.4h1.5c1.89,0,3.43,1.53,3.43,3.4v3.17c0,1.88-1.54,3.4-3.43,3.4"
            />
            <path
              style={{ fill: color }}
              d="m18.32,36.35c-.8,0-1.46.65-1.46,1.45v3.17c0,.8.65,1.45,1.46,1.45h1.5c.8,0,1.46-.65,1.46-1.45v-3.17c0-.8-.65-1.45-1.46-1.45h-1.5Zm1.5,8.02h-1.5c-1.89,0-3.43-1.53-3.43-3.4v-3.17c0-1.88,1.54-3.4,3.43-3.4h1.5c1.89,0,3.43,1.53,3.43,3.4v3.17c0,1.88-1.54,3.4-3.43,3.4"
            />
            <path
              style={{ fill: color }}
              d="m18.32,48.94c-.8,0-1.46.65-1.46,1.44v3.17c0,.8.65,1.45,1.46,1.45h1.5c.8,0,1.46-.65,1.46-1.45v-3.17c0-.8-.65-1.44-1.46-1.44h-1.5Zm1.5,8.02h-1.5c-1.89,0-3.43-1.53-3.43-3.4v-3.17c0-1.88,1.54-3.4,3.43-3.4h1.5c1.89,0,3.43,1.53,3.43,3.4v3.17c0,1.88-1.54,3.4-3.43,3.4"
            />
            <path
              style={{ fill: color }}
              d="m29.31,23.49c-.8,0-1.46.65-1.46,1.44v3.17c0,.8.65,1.45,1.46,1.45h1.5c.8,0,1.46-.65,1.46-1.45v-3.17c0-.8-.65-1.44-1.46-1.44h-1.5Zm1.5,8.02h-1.5c-1.89,0-3.43-1.53-3.43-3.4v-3.17c0-1.88,1.54-3.4,3.43-3.4h1.5c1.89,0,3.43,1.53,3.43,3.4v3.17c0,1.88-1.54,3.4-3.43,3.4"
            />
            <path
              style={{ fill: color }}
              d="m29.31,36.35c-.8,0-1.46.65-1.46,1.45v3.17c0,.8.65,1.45,1.46,1.45h1.5c.8,0,1.46-.65,1.46-1.45v-3.17c0-.8-.65-1.45-1.46-1.45h-1.5Zm1.5,8.02h-1.5c-1.89,0-3.43-1.53-3.43-3.4v-3.17c0-1.88,1.54-3.4,3.43-3.4h1.5c1.89,0,3.43,1.53,3.43,3.4v3.17c0,1.88-1.54,3.4-3.43,3.4"
            />
            <path
              style={{ fill: color }}
              d="m29.31,48.94c-.8,0-1.46.65-1.46,1.44v3.17c0,.8.65,1.45,1.46,1.45h1.5c.8,0,1.46-.65,1.46-1.45v-3.17c0-.8-.65-1.44-1.46-1.44h-1.5Zm1.5,8.02h-1.5c-1.89,0-3.43-1.53-3.43-3.4v-3.17c0-1.88,1.54-3.4,3.43-3.4h1.5c1.89,0,3.43,1.53,3.43,3.4v3.17c0,1.88-1.54,3.4-3.43,3.4"
            />
            <path
              style={{ fill: color }}
              d="m7.6,23.49c-.8,0-1.46.65-1.46,1.44v3.17c0,.8.65,1.45,1.46,1.45h1.5c.8,0,1.46-.65,1.46-1.45v-3.17c0-.8-.65-1.44-1.46-1.44h-1.5Zm1.5,8.02h-1.5c-1.89,0-3.43-1.53-3.43-3.4v-3.17c0-1.88,1.54-3.4,3.43-3.4h1.5c1.89,0,3.43,1.53,3.43,3.4v3.17c0,1.88-1.54,3.4-3.43,3.4"
            />
            <path
              style={{ fill: color }}
              d="m10.56,53.55c0,.8-.65,1.45-1.45,1.45h-1.51c-.8,0-1.45-.65-1.45-1.45v-15.75c0-.8.65-1.45,1.45-1.45h1.51c.8,0,1.45.65,1.45,1.45v15.75Zm-1.45-19.16h-1.51c-1.89,0-3.43,1.53-3.43,3.4v15.75c0,1.88,1.54,3.4,3.43,3.4h1.51c1.89,0,3.43-1.53,3.43-3.4v-15.75c0-1.88-1.54-3.4-3.43-3.4"
            />
            <path
              style={{ fill: color }}
              d="m40.03,23.49c-.8,0-1.46.65-1.46,1.44v3.17c0,.8.65,1.45,1.46,1.45h1.5c.8,0,1.46-.65,1.46-1.45v-3.17c0-.8-.65-1.44-1.46-1.44h-1.5Zm1.5,8.02h-1.5c-1.89,0-3.43-1.53-3.43-3.4v-3.17c0-1.88,1.54-3.4,3.43-3.4h1.5c1.89,0,3.43,1.53,3.43,3.4v3.17c0,1.88-1.54,3.4-3.43,3.4"
            />
            <path
              style={{ fill: color }}
              d="m40.03,36.35c-.8,0-1.46.65-1.46,1.45v3.17c0,.8.65,1.45,1.46,1.45h1.5c.8,0,1.46-.65,1.46-1.45v-3.17c0-.8-.65-1.45-1.46-1.45h-1.5Zm1.5,8.02h-1.5c-1.89,0-3.43-1.53-3.43-3.4v-3.17c0-1.88,1.54-3.4,3.43-3.4h1.5c1.89,0,3.43,1.53,3.43,3.4v3.17c0,1.88-1.54,3.4-3.43,3.4"
            />
            <path
              style={{ fill: color }}
              d="m40.03,48.94c-.8,0-1.46.65-1.46,1.44v3.17c0,.8.65,1.45,1.46,1.45h1.5c.8,0,1.46-.65,1.46-1.45v-3.17c0-.8-.65-1.44-1.46-1.44h-1.5Zm1.5,8.02h-1.5c-1.89,0-3.43-1.53-3.43-3.4v-3.17c0-1.88,1.54-3.4,3.43-3.4h1.5c1.89,0,3.43,1.53,3.43,3.4v3.17c0,1.88-1.54,3.4-3.43,3.4"
            />
          </g>
        </g>
      </svg>
    </>
  );
};

export const HomePageBannerIcon = () => {
  const color = "#10b6eb";
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="15 10 59.13 61.42">
        <path
          style={{ fill: color }}
          d="m15.21,38.16c.34-.35.63-.76,1.02-1.05,8.35-6.13,16.71-12.25,25.08-18.37,1.05-.77,1.4-.76,2.47.02,8.4,6.15,16.81,12.3,25.21,18.45.57.42.97.91.8,1.66-.23,1.03-1.37,1.43-2.27.79-1.26-.9-2.5-1.82-3.75-2.73-6.93-5.07-13.85-10.14-20.77-15.22-.36-.26-.58-.27-.95,0-8.08,5.93-16.17,11.85-24.26,17.77-1.14.83-1.93.66-2.59-.56v-.75Z"
        />
        <path
          style={{ fill: color }}
          d="m49.62,64.02h11.36v-.63c0-7.23,0-14.47,0-21.71,0-1.06.6-1.69,1.52-1.63.63.04,1.15.48,1.27,1.1.04.19.05.39.05.58,0,7.8,0,15.61,0,23.41,0,.11,0,.21,0,.32-.08.88-.61,1.39-1.5,1.4-4.68,0-9.35,0-14.03,0-.97,0-1.49-.59-1.49-1.61,0-4.48,0-8.96,0-13.44,0-2.39-1.78-4.27-4.08-4.36-2.44-.1-4.43,1.82-4.44,4.32-.01,4.37,0,8.75,0,13.12,0,.16,0,.32,0,.48-.02.92-.57,1.49-1.5,1.49-4.68,0-9.35,0-14.03,0-.88,0-1.42-.53-1.49-1.41-.01-.18,0-.35,0-.53,0-7.64,0-15.29,0-22.93,0-.25,0-.5.03-.74.11-.74.71-1.23,1.45-1.2.71.03,1.27.56,1.34,1.28.02.19.01.39.01.59v22.1h11.36v-.64c0-3.84-.01-7.68,0-11.52.01-3.43,2.14-6.2,5.36-7.03,4.22-1.09,8.48,1.96,8.79,6.3.05.73.04,1.46.04,2.18,0,3.34,0,6.68,0,10.03v.69"
        />
      </svg>
    </>
  );
};

export const PopularARAvatarIcon = () => {
  const color = "#10b6eb";
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="15 10 59.13 61.42">
        <polygon
          fill="none"
          style={{ stroke: color, strokeMiterlimit: 10, strokeWidth: "3px" }}
          points="42.52 18.27 50.4 34.24 68.01 36.8 55.27 49.22 58.28 66.77 42.52 58.48 26.76 66.77 29.77 49.22 17.03 36.8 34.64 34.24 42.52 18.27"
        />
        <path
          fill={color}
          d="m48.82,53.53l-.02.19h-12.58v-.2c-.06-.92.19-1.72.74-2.39.67-.81,1.54-1.23,2.6-1.24.14,0,.28,0,.42,0,.15,0,.3,0,.45,0,.18,0,.31.08.37.26.29.76.95,1.23,1.72,1.23h0c.77,0,1.42-.47,1.72-1.22.04-.1.16-.26.32-.26h0c.13,0,.27,0,.4,0,.46,0,.93-.01,1.4.12,1.56.43,2.64,1.97,2.46,3.52m-5.14-4.74v.22c-.02.08-.02.16-.02.24,0,.18,0,.37-.05.56-.1.51-.57.88-1.1.88-.04,0-.08,0-.13,0-.56-.06-.99-.54-1.01-1.11,0-.13,0-.26,0-.39v-.39h2.3Zm-3.18-2.04c-.71-.47-1.22-1.1-1.5-1.89-.35-.99-.28-2.04.2-2.97.48-.92,1.33-1.61,2.34-1.89,1-.27,2.08-.11,2.96.45.88.55,1.48,1.44,1.66,2.45.28,1.55-.26,2.86-1.56,3.79-.49.35-.77.71-.89,1.14-.04.13-.18.23-.3.25-.05,0-.1.01-.15.01-.03,0-.06,0-.1,0-.03,0-.06,0-.1,0h-.21v-.21c0-.24,0-.48,0-.72,0-.61,0-1.18,0-1.76,0-.27.03-.62.38-.91.15-.12.28-.27.43-.42.05-.06.11-.11.16-.17.1-.1.15-.21.15-.31,0-.08-.03-.16-.1-.22-.15-.15-.35-.13-.52.05-.15.15-.3.3-.45.46-.07.07-.14.14-.21.22l-.15.15-.66-.65s-.05-.05-.07-.07c-.05-.05-.1-.1-.15-.14-.15-.14-.35-.14-.49,0-.14.14-.14.34,0,.49.14.15.29.3.44.45.13.13.27.27.41.41.07.08.16.21.16.35,0,.76,0,1.54,0,2.29v.43s0,.06,0,.08l-.02.16-.14.04s-.06.02-.1.02c-.42.02-.5-.04-.65-.43-.14-.37-.39-.67-.75-.91m9.03,7.15c-.01-.14,0-.28,0-.41,0-.1,0-.19,0-.28-.05-1.42-.67-2.54-1.84-3.34-.63-.43-1.37-.65-2.18-.66-.21,0-.43,0-.64,0h-.52v-.21c0-.06,0-.11,0-.16,0-.1,0-.2,0-.28-.06-.68.33-1.05.67-1.3,1.48-1.06,2.11-2.5,1.86-4.27-.16-1.18-.77-2.22-1.72-2.92-.97-.72-2.18-1-3.39-.8-1.26.21-2.36.97-3.03,2.09-.67,1.13-.82,2.47-.39,3.68.32.93.9,1.68,1.71,2.23.23.15.53.36.6.75.04.23.05.45.05.68,0,.1,0,.19.01.29v.23s-.21,0-.21,0h-.34c-.22,0-.43,0-.65,0-1.72.02-3.24,1.13-3.8,2.77-.2.58-.2,1.18-.21,1.81v.1c0,.28.06.43.25.53h13.52c.19-.1.27-.26.25-.52Z"
        />
        <path
          fill={color}
          d="m42.18,36.95c0,.1,0,.21,0,.31,0,.22.14.38.34.38s.34-.16.34-.38c0-.1,0-.21,0-.31,0-.19,0-.39,0-.58.02-.26-.05-.42-.25-.52h-.2c-.19.1-.27.26-.25.52.01.2.01.4,0,.59"
        />
        <path
          fill={color}
          d="m35.91,40.17h0c.27.17.64.38,1.01.58.15.08.35.02.44-.13.09-.16.05-.36-.1-.45-.4-.26-.72-.44-1.02-.59-.05-.03-.1-.04-.15-.04-.06,0-.11.02-.16.05-.1.06-.16.17-.16.29,0,.13.05.22.15.28"
        />
        <path
          fill={color}
          d="m47.67,40.62c.04.08.12.14.2.16.09.02.19.01.27-.04.31-.17.62-.35.91-.53l.04-.02c.11-.07.17-.16.17-.23,0-.16-.06-.3-.18-.37-.05-.03-.1-.04-.16-.04s-.11.02-.17.05c-.33.18-.65.37-.95.55-.18.1-.23.3-.14.47"
        />
        <path
          fill={color}
          d="m39.08,38.31h0c.1.17.3.23.47.13.17-.1.22-.3.12-.47-.16-.29-.33-.58-.56-.97-.07-.11-.16-.16-.3-.16-.12,0-.23.06-.29.16-.06.1-.06.23,0,.35.15.28.32.58.56.97"
        />
        <path
          fill={color}
          d="m45.49,38.44c.16.09.35.05.45-.09.24-.38.43-.71.59-1.02.05-.11.05-.22-.01-.32-.06-.1-.17-.16-.3-.16h0c-.09,0-.2.03-.27.14-.23.37-.41.69-.58,1.01-.08.16-.03.35.13.44"
        />
      </svg>
    </>
  );
};

export const OneToOneLiveVideoShoppingIcon = () => {
  const color = "#10b6eb";
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="9 10 69.13 61.42">
        <path
          fill={color}
          d="m70.14,58.99c-1.11,0-2.23,0-3.39,0V26.09c1.42,0,2.79-.05,4.17.01,1.39.06,2.47,1.01,2.61,2.17.02.22.02.44.02.66,0,9.06,0,18.13,0,27.19,0,1.94-1.1,2.86-3.4,2.86m-6.1-.03h-10.76c0-.07,0-.13,0-.2v-1.66c0-2.38,0-4.75,0-7.12,0-1.87-.88-3.2-2.58-3.95-1.2-.52-2.42-1.07-3.73-1.66-.26-.12-.45-.42-.51-.8-.06-.4.03-.77.25-.97,1-.92,1.59-1.9,1.8-2.98.11-.58.15-1.17.18-1.75.02-.33.04-.68.08-1.02.02-.16.1-.35.19-.45.38-.4.57-.88.55-1.41-.09-2.52-1.25-4.39-3.44-5.55-1.64-.86-3.4-.77-5.07-.6-1.82.18-3.3,1.09-4.41,2.7-1.19,1.73-1.16,3.7-.99,5.22.02.23.15.42.27.59.05.08.1.15.14.23.03.06.07.13.1.19.08.14.16.28.17.39.09,1.73.7,3.13,1.79,4.17.42.4.5.79.48,1.29-.01.42-.15.64-.52.79-.7.3-1.4.62-2.09.92-.54.24-1.07.48-1.61.71-1.72.75-2.59,2.09-2.59,3.99,0,2.91,0,5.82,0,8.74v.07s0,.09,0,.13h-10.74V26.1l43.03.02v32.85Zm-14.52-.26c0-.55,0-1.1,0-1.65,0-1.41,0-2.88.01-4.31,0-.18,0-.67.17-.87.43-.53.92-1.03,1.43-1.56.08-.08.16-.17.25-.25,0,.02,0,.04,0,.06v8.61c0,.07,0,.15,0,.23h-1.88c0-.08.01-.17.01-.26m-6.04.08s0-.09,0-.14v-2.6c0-2.26,0-4.53.01-6.79,0-.17.08-.39.17-.49.48-.5.98-1,1.47-1.49.34-.34.68-.67,1.01-1.01.12-.12.15-.12.29-.06.62.28,1.24.56,1.85.83.6.26,1.2.53,1.79.8.16.07.32.18.5.31.01,0,.02.02.03.02-.15.15-.3.3-.45.45-.48.48-.93.93-1.39,1.37-.8.76-1.18,1.67-1.17,2.78.01,1.37.01,2.76,0,4.11,0,.62,0,1.24,0,1.86,0,.08,0,.16,0,.23h-4.13c0-.06,0-.12,0-.18m-7.13-8.72c-.5-.49-1-.99-1.49-1.49l-.3-.3s-.07-.08-.11-.12c0,0,.02-.01.02-.02.16-.11.31-.21.45-.28,1.46-.66,2.64-1.18,3.73-1.64.05-.02.2.03.24.07.41.39.81.79,1.21,1.19.39.39.8.8,1.2,1.19.2.19.27.38.27.68-.01,2.82,0,5.69,0,8.47v.83c0,.11,0,.21,0,.32h-4.15s0-.05,0-.08c0-.83,0-1.66,0-2.49,0-1.25,0-2.5,0-3.76,0-1-.35-1.85-1.09-2.57m-2.68,8.76s0-.1,0-.14c0-2.33,0-4.66,0-7v-1.6s.09.09.13.13c.38.38.74.75,1.11,1.09.45.41.65.88.64,1.52-.02,1.77-.02,3.57,0,5.32v.75s0,.05,0,.08h-1.86s0-.1,0-.14m6.57-14.03c.06-.27.13-.54.2-.82l.02-.08c1.39.45,2.78.45,4.13,0,0,.03.02.06.02.08.08.31.16.59.22.87,0,.02-.02.08-.04.1-.61.62-1.23,1.24-1.87,1.89l-.38.39-.35-.35c-.67-.66-1.31-1.31-1.95-1.96,0-.02-.01-.07,0-.11m-1.86-7.04c.13-.11.28-.2.43-.3.15-.1.31-.19.45-.31.47-.36.57-.94.25-1.37-.18-.24-.44-.37-.71-.37-.21,0-.44.07-.67.22-.22.14-.43.28-.66.43-.16-1.53.21-2.9,1.06-3.89.83-.96,2.05-1.5,3.45-1.5.01,0,.02,0,.03,0h.32c.83,0,1.62,0,2.4.26,1.65.55,2.96,2.44,2.85,4.05-2.24.35-4.58.39-6.61-1.38-.47-.4-1.01-.41-1.39,0-.18.18-.26.41-.26.65,0,.28.14.55.39.78,1.18,1.1,2.59,1.74,4.18,1.9.73.07,1.48.06,2.2.04.25,0,.5-.01.75-.01.14,1.91-.29,3.21-1.37,4.19-1.32,1.2-2.85,1.49-4.55.86-1.55-.57-2.74-2.33-2.71-4.01,0-.04.07-.15.17-.23m-20.05,21.18c-1.52,0-3.03.1-4.51-.03-1.32-.11-2.21-1.11-2.29-2.22-.01-.18,0-.37,0-.55v-27.19c0-1.94,1.1-2.86,3.4-2.86h3.41v32.85Zm51.22-35.07c-4.6.1-49.59.03-54.82.02-1.55,0-2.93.37-4.08,1.25-.99.76-1.47,1.74-1.76,2.81v29.18c.31,1.14.85,2.17,1.96,2.95,1.15.8,2.48,1.11,3.95,1.11,9.24,0,18.47,0,27.71,0s18.52,0,27.78,0c2.4,0,4.23-.81,5.33-2.62.27-.45.39-.96.58-1.44v-29.18c-.71-2.94-3.33-4.16-6.63-4.08"
        />
        <path
          fill={color}
          d="m15.24,39.1c-.76.02-1.25.47-1.27,1.22-.01.73,0,1.46,0,2.19s-.01,1.5,0,2.25c.01.74.51,1.2,1.27,1.21.76.01,1.32-.43,1.34-1.16.03-1.52.03-3.03,0-4.55-.02-.73-.58-1.17-1.34-1.16"
        />
        <path
          fill={color}
          d="m71.43,40.02c-.01-.79-.54-1.3-1.33-1.28-.77.01-1.28.5-1.29,1.26-.01,1.72,0,3.43,0,5.15,0,.79.54,1.3,1.33,1.28.77-.01,1.28-.5,1.29-1.26.01-.86,0-1.72,0-2.57s0-1.72,0-2.57"
        />
        <path
          fill={color}
          d="m70.09,36.18c.71.01,1.32-.47,1.33-1.05.02-.57-.58-1.09-1.28-1.11-.69-.01-1.31.48-1.33,1.06-.02.58.57,1.09,1.27,1.1"
        />
        <path
          fill={color}
          d="m70.14,48.88c-.71,0-1.31.48-1.32,1.07,0,.57.6,1.09,1.29,1.1.69,0,1.31-.5,1.32-1.07,0-.58-.59-1.08-1.29-1.09"
        />
      </svg>
    </>
  );
};

export const ARAvatarIcon = () => {
  const color = "#10b6eb";
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="15 10 59.13 61.42">
        <path
          fill={color}
          d="m60.24,66.14l-.06.53H24.8l-.03-.56c-.15-2.58.56-4.84,2.12-6.72,1.88-2.27,4.33-3.44,7.3-3.48.39,0,.79,0,1.18,0,.42,0,.84,0,1.26,0,.52,0,.86.23,1.05.72.82,2.13,2.67,3.46,4.83,3.46h.01c2.15,0,4-1.32,4.83-3.43.11-.29.45-.72.9-.72h0c.37,0,.76,0,1.13,0,1.28-.02,2.61-.04,3.94.32,4.38,1.2,7.42,5.55,6.9,9.91m-14.45-13.33l-.04.63c-.01.23-.02.45-.02.67-.01.51-.02,1.04-.13,1.56-.29,1.44-1.61,2.47-3.08,2.47-.12,0-.24,0-.36-.02-1.58-.18-2.8-1.51-2.84-3.11-.01-.36,0-.72,0-1.09,0-.17,0-.34,0-.51v-.6h6.47Zm-8.94-5.74c-2-1.31-3.42-3.1-4.21-5.3-.99-2.77-.79-5.74.57-8.36,1.35-2.6,3.75-4.53,6.58-5.31,2.8-.77,5.84-.31,8.32,1.26,2.46,1.55,4.16,4.06,4.67,6.89.78,4.36-.73,8.04-4.39,10.66-1.39.99-2.16,1.98-2.51,3.22-.1.37-.51.64-.83.69-.15.02-.29.03-.43.03-.09,0-.18,0-.27,0-.09,0-.18,0-.28,0h-.6v-.6c0-.68,0-1.36,0-2.03,0-1.7.02-3.31-.02-4.95-.02-.76.08-1.74,1.07-2.55.42-.35.8-.75,1.2-1.17.15-.16.3-.32.45-.47.27-.28.42-.59.41-.88,0-.23-.1-.45-.29-.63-.42-.41-.99-.36-1.47.13-.42.42-.83.84-1.27,1.29-.2.2-.4.41-.6.62l-.42.43-1.84-1.84c-.07-.07-.13-.14-.2-.2-.14-.14-.27-.28-.41-.4-.43-.39-1-.4-1.38-.02-.39.39-.38.96,0,1.37.4.42.82.84,1.23,1.25.38.38.77.76,1.14,1.16.21.22.44.59.44.98.01,2.15.01,4.34.01,6.45v1.21c0,.09-.01.16-.02.22l-.05.44-.4.12c-.06.02-.16.06-.29.06-1.17.04-1.42-.12-1.83-1.21-.4-1.04-1.09-1.88-2.12-2.55m25.38,20.09c-.03-.39-.02-.78-.02-1.15,0-.28,0-.54,0-.8-.14-3.99-1.88-7.15-5.16-9.38-1.78-1.21-3.85-1.84-6.14-1.86-.6,0-1.2,0-1.81,0-.28,0-.57,0-.86,0h-.6v-.6c0-.16,0-.31,0-.46,0-.29.01-.55,0-.79-.17-1.92.93-2.96,1.89-3.65,4.16-2.98,5.92-7.02,5.24-12-.45-3.32-2.17-6.23-4.85-8.2-2.73-2.02-6.12-2.82-9.54-2.25-3.54.58-6.64,2.73-8.52,5.88-1.89,3.17-2.29,6.95-1.11,10.36.91,2.62,2.52,4.74,4.8,6.28.64.43,1.5,1.02,1.68,2.1.11.63.13,1.28.15,1.9,0,.27.02.54.03.81l.04.63h-.63c-.33,0-.64,0-.95,0-.63,0-1.22,0-1.81,0-4.83.05-9.12,3.18-10.67,7.78-.55,1.63-.57,3.31-.6,5.08v.29c-.02.79.18,1.22.7,1.49h38.02c.54-.29.75-.74.7-1.46Z"
        />
        <path
          fill={color}
          d="m41.56,19.54c0,.29,0,.58,0,.87,0,.63.4,1.07.96,1.07s.96-.44.96-1.07c0-.3,0-.59,0-.88,0-.54-.02-1.09.02-1.64.05-.74-.16-1.17-.7-1.46h-.55c-.54.29-.75.72-.7,1.46.04.56.03,1.12.02,1.66"
        />
        <path
          fill={color}
          d="m23.95,28.6h0c.77.47,1.79,1.08,2.84,1.64.43.23.97.07,1.23-.38.26-.45.14-1-.28-1.26-1.14-.72-2.02-1.23-2.87-1.66-.14-.07-.28-.1-.42-.1-.16,0-.32.04-.46.13-.29.17-.46.48-.46.82,0,.37.13.63.41.8"
        />
        <path
          fill={color}
          d="m57,29.84c.12.23.33.39.57.46.25.07.52.03.77-.1.86-.48,1.73-.99,2.57-1.49l.1-.06c.32-.19.47-.46.48-.64,0-.46-.18-.84-.5-1.03-.14-.08-.29-.12-.44-.12s-.33.04-.49.13c-.92.5-1.83,1.04-2.67,1.54-.49.3-.66.84-.39,1.31"
        />
        <path
          fill={color}
          d="m32.84,23.37h0c.29.48.84.63,1.31.36.47-.27.61-.83.34-1.32-.44-.8-.92-1.64-1.57-2.72-.18-.31-.45-.45-.83-.45-.34,0-.64.17-.81.45-.17.29-.18.65,0,.97.42.79.9,1.63,1.56,2.72"
        />
        <path
          fill={color}
          d="m50.88,23.72c.44.27.99.15,1.25-.27.68-1.08,1.21-1.99,1.66-2.87.15-.3.14-.63-.03-.9-.18-.28-.49-.45-.83-.45h-.01c-.24,0-.57.07-.76.4-.63,1.05-1.15,1.94-1.64,2.85-.24.44-.08.98.37,1.24"
        />
      </svg>
    </>
  );
};

export const PopularProductsFeatureSpotIcon = () => {
  const color = "#10b6eb";
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="15 10 59.13 61.42">
        <polygon
          fill="none"
          style={{ stroke: color, strokeMiterlimit: 10, strokeWidth: "3px" }}
          points="42.52 18.27 50.4 34.24 68.01 36.8 55.27 49.22 58.28 66.77 42.52 58.48 26.76 66.77 29.77 49.22 17.03 36.8 34.64 34.24 42.52 18.27"
        />
        <path
          fill={color}
          d="m44.83,39.25c0-.52.05-1.03-.01-1.52-.14-1.04-1.09-1.88-2.12-1.93-1.17-.06-2.17.65-2.45,1.72-.15.56-.07,1.13-.08,1.7,0,0,.02.02.02.03h4.63Zm4.35,13.4c-.36-4-.72-7.98-1.07-11.96h-1.83v.63c0,.2,0,.41,0,.61-.02.5-.48.83-.94.67-.29-.1-.47-.36-.48-.72,0-.39,0-.79,0-1.2h-4.69c0,.07,0,.13,0,.2,0,.35,0,.69,0,1.04-.02.51-.46.83-.93.68-.3-.09-.48-.36-.49-.71,0-.4,0-.8,0-1.21h-1.83c-.36,3.99-.72,7.97-1.07,11.96h13.34Zm-6.28-18.27c.16.04.32.07.48.11,1.73.43,2.88,1.89,2.9,3.67,0,.36,0,.72,0,1.1h.22c.72,0,1.44,0,2.15,0,.5,0,.76.23.81.73.08.89.16,1.79.24,2.68.12,1.38.25,2.76.37,4.14.11,1.2.22,2.4.32,3.6.08.94.16,1.88.25,2.81.05.5-.25.86-.75.86-4.93,0-9.86,0-14.79,0-.49,0-.79-.35-.75-.84.19-2.12.38-4.25.57-6.37.2-2.21.4-4.41.6-6.62.01-.12.02-.24.04-.36.07-.38.33-.61.72-.61.76,0,1.53,0,2.29,0h.16v-.47c0-.53-.01-1.06.12-1.59.38-1.46,1.61-2.57,3.1-2.79.06,0,.11-.03.16-.04h.77Z"
        />
      </svg>
    </>
  );
};

export const ARShopInShopIcon = () => {
  const color = "#10b6eb";
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="15 10 59.13 61.42">
        <polygon
          fill={color}
          points="17.17 28.19 19.27 28.19 19.27 19.66 27.61 19.66 27.61 17.52 17.17 17.52 17.17 28.19"
        />
        <polygon
          fill={color}
          points="57.43 17.52 57.43 19.66 65.77 19.66 65.77 28.19 67.87 28.19 67.87 17.52 57.43 17.52"
        />
        <polygon
          fill={color}
          points="65.77 65.38 57.43 65.38 57.43 67.52 67.87 67.52 67.87 56.85 65.77 56.85 65.77 65.38"
        />
        <polygon
          fill={color}
          points="19.27 56.85 17.17 56.85 17.17 67.52 27.61 67.52 27.61 65.38 19.27 65.38 19.27 56.85"
        />
        <path
          fill={color}
          d="m46.35,34.3c0-.86.09-1.7-.02-2.51-.23-1.73-1.8-3.11-3.5-3.2-1.93-.09-3.59,1.07-4.05,2.84-.24.93-.12,1.88-.12,2.81,0,.02.02.03.04.05h7.65Zm7.2,22.14c-.59-6.61-1.18-13.18-1.77-19.76h-3.02v1.04c0,.34,0,.68,0,1.02-.03.83-.79,1.36-1.55,1.1-.48-.17-.78-.6-.79-1.19,0-.65,0-1.31,0-1.98h-7.76c0,.12-.01.22-.01.33,0,.57.01,1.15,0,1.72-.03.84-.76,1.38-1.53,1.13-.49-.16-.8-.6-.81-1.17,0-.66,0-1.33,0-2h-3.02c-.59,6.59-1.18,13.17-1.77,19.77h22.04Zm-10.38-30.2c.27.06.53.11.8.18,2.86.72,4.76,3.12,4.79,6.07,0,.59,0,1.18,0,1.82h.36c1.19,0,2.37,0,3.56,0,.82,0,1.26.39,1.34,1.2.14,1.47.26,2.95.4,4.43.2,2.28.41,4.56.61,6.83.18,1.98.35,3.97.53,5.95.14,1.55.27,3.1.42,4.65.08.83-.41,1.41-1.23,1.41-8.15,0-16.29,0-24.44,0-.81,0-1.31-.58-1.24-1.39.32-3.51.63-7.02.95-10.53.33-3.65.66-7.3.99-10.95.02-.2.03-.4.06-.6.11-.63.55-1.01,1.19-1.01,1.26,0,2.52,0,3.78,0h.26c0-.27,0-.52,0-.77,0-.88-.02-1.76.2-2.62.62-2.42,2.65-4.25,5.12-4.61.09-.01.18-.05.27-.07h1.27Z"
        />
      </svg>
    </>
  );
};

export const ARModelProductionIcon = () => {
  const color = "#10b6eb";
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="15 10 59.13 61.42">
        <polygon
          fill={color}
          points="17.17 28.19 19.27 28.19 19.27 19.66 27.61 19.66 27.61 17.52 17.17 17.52 17.17 28.19"
        />
        <polygon
          fill={color}
          points="57.43 17.52 57.43 19.66 65.77 19.66 65.77 28.19 67.87 28.19 67.87 17.52 57.43 17.52"
        />
        <polygon
          fill={color}
          points="65.77 65.38 57.43 65.38 57.43 67.52 67.87 67.52 67.87 56.85 65.77 56.85 65.77 65.38"
        />
        <polygon
          fill={color}
          points="19.27 56.85 17.17 56.85 17.17 67.52 27.61 67.52 27.61 65.38 19.27 65.38 19.27 56.85"
        />
        <path
          fill={color}
          d="m43.49,48.26l8.23,2.93-8.23,2.71v-5.64Zm-1.93,0v5.64l-8.23-2.71,8.23-2.93Zm1.93-9.14l10.32-3.4v14.11l-10.32-3.67v-7.04Zm-12.25-3.4l10.32,3.4v7.04l-10.32,3.67v-14.11Zm11.28-4.9l9.53,3.4-9.53,3.14-9.53-3.14,9.53-3.4Zm13.21,3.42c.05-.45-.21-.89-.64-1.05l-12.25-4.36s-.02,0-.03,0c-.03-.01-.07-.02-.1-.02-.03,0-.06-.01-.09-.02-.03,0-.06,0-.1,0-.03,0-.06,0-.09,0-.03,0-.06,0-.09.02-.03,0-.06.01-.1.02-.01,0-.02,0-.03,0l-12.25,4.36c-.44.16-.69.6-.64,1.05,0,.02,0,.05,0,.07,0,.02,0,.03,0,.05v16.87s0,.03,0,.04c0,.02,0,.05,0,.07,0,.02,0,.04,0,.05,0,.03.01.05.01.07,0,.02.01.04.02.06,0,0,0,.02,0,.02,0,.01.01.02.02.03,0,.02.02.04.03.06,0,.01.01.03.02.04.01.02.02.04.04.06.01.02.02.03.03.05,0,.01.02.03.02.04,0,0,.01.02.02.02.01.01.02.03.04.04,0,.01.02.02.02.03.01,0,.02.02.03.03.01.01.03.03.05.04.02.02.04.03.05.04.01,0,.02.01.04.02,0,0,0,0,0,0,.02.01.03.02.05.03.02.01.04.02.05.03.02,0,.04.02.06.02.01,0,.02.01.04.02,0,0,0,0,.01,0l12.25,4.04s.04.01.06.02c.02,0,.04.01.06.01,0,0,.02,0,.03,0,.05,0,.09,0,.14.01,0,0,0,0,.01,0h0s0,0,.01,0c.05,0,.09,0,.14-.01,0,0,.02,0,.03,0,.02,0,.04,0,.06-.01.02,0,.04,0,.06-.02l12.25-4.04s0,0,0,0c.01,0,.02-.01.04-.02.02,0,.04-.01.06-.02.02,0,.04-.02.06-.03.02,0,.03-.02.05-.03,0,0,0,0,0,0,.01,0,.02-.01.04-.02.02-.01.04-.03.05-.04.01-.01.03-.02.04-.04.01-.01.02-.02.03-.03,0,0,.02-.02.02-.03.01-.01.03-.03.04-.04,0,0,.01-.02.02-.02,0-.01.02-.02.03-.04.01-.02.02-.03.03-.05.01-.02.03-.04.04-.06,0-.01.01-.03.02-.04,0-.02.02-.04.03-.06,0-.01,0-.02.01-.03,0,0,0-.02,0-.02,0-.02.01-.04.02-.06,0-.02.01-.05.01-.07,0-.02,0-.04,0-.05,0-.02,0-.04,0-.07,0-.01,0-.03,0-.04v-16.87s0-.03,0-.05c0-.02,0-.04,0-.07"
        />
      </svg>
    </>
  );
};

export const VirtualExperiencesIcon = () => {
  const color = "#10b6eb";
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="15 10 59.13 61.42">
        <path
          fill={color}
          d="m59.11,38.64c-.48,0-.91-.32-1.04-.8-.15-.58.19-1.17.77-1.32,5.76-1.53,9.47-3.93,9.47-6.13s-3.72-4.6-9.47-6.13c-.58-.15-.92-.74-.77-1.32.15-.58.75-.91,1.32-.77,7.04,1.86,11.08,4.86,11.08,8.21s-4.04,6.35-11.08,8.21c-.09.02-.19.04-.28.04"
        />
        <path
          fill={color}
          d="m59.11,50.19c-.09,0-.18-.01-.27-.03-9.49-2.4-23.09-2.42-32.65,0-.58.15-1.17-.2-1.31-.78-.15-.58.2-1.16.78-1.31,9.9-2.51,23.88-2.49,33.71,0,.58.15.93.73.78,1.31-.12.49-.56.81-1.04.81"
        />
        <path
          fill={color}
          d="m15.65,57.42c-.6,0-1.08-.48-1.08-1.08v-25.95c0-.6.48-1.08,1.08-1.08s1.08.48,1.08,1.08v25.95c0,.6-.48,1.08-1.08,1.08"
        />
        <path
          fill={color}
          d="m69.39,57.42c-.6,0-1.08-.48-1.08-1.08v-25.95c0-.6.48-1.08,1.08-1.08s1.08.48,1.08,1.08v25.95c0,.6-.48,1.08-1.08,1.08"
        />
        <path
          fill={color}
          d="m25.93,64.59c-.6,0-1.08-.48-1.08-1.08v-25.95c0-.6.48-1.08,1.08-1.08s1.08.48,1.08,1.08v25.95c0,.6-.48,1.08-1.08,1.08"
        />
        <path
          fill={color}
          d="m59.11,64.59c-.6,0-1.08-.48-1.08-1.08v-25.95c0-.6.48-1.08,1.08-1.08s1.08.48,1.08,1.08v25.95c0,.6-.48,1.08-1.08,1.08"
        />
        <path
          fill={color}
          d="m25.93,64.59c-.1,0-.19-.01-.29-.04-7.14-1.96-11.07-4.88-11.07-8.21,0-.6.48-1.08,1.08-1.08s1.08.48,1.08,1.08c0,2.17,3.63,4.52,9.48,6.13.58.16.91.75.76,1.33-.13.48-.57.79-1.04.79"
        />
        <path
          fill={color}
          d="m59.11,64.59c-.47,0-.91-.31-1.04-.79-.16-.57.18-1.17.76-1.33,5.85-1.61,9.48-3.95,9.48-6.13,0-.6.48-1.08,1.08-1.08s1.08.48,1.08,1.08c0,3.33-3.93,6.25-11.07,8.21-.1.03-.19.04-.29.04"
        />
        <path
          fill={color}
          d="m25.93,38.64c-.09,0-.19-.01-.28-.04-7.04-1.86-11.08-4.86-11.08-8.21s4.04-6.35,11.08-8.21c.57-.14,1.17.19,1.32.77.15.58-.19,1.17-.77,1.32-5.76,1.52-9.47,3.93-9.47,6.13s3.72,4.6,9.47,6.13c.58.15.92.74.77,1.32-.13.48-.56.8-1.04.8"
        />
        <path
          fill={color}
          d="m60.15,24.45c-.09,0-.19-.01-.28-.03-9.92-2.4-24.12-2.42-34.11,0-.6.15-1.22-.2-1.37-.78-.15-.58.21-1.16.82-1.31,10.34-2.51,24.95-2.49,35.21,0,.6.15.97.73.82,1.31-.13.49-.59.81-1.09.81"
        />
      </svg>
    </>
  );
};

export const ProductPagesDeployment = () => {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 85.04 85.04"
    >
      <defs>
        <clipPath id="clippathProduct">
          <rect
            style={{ fill: "none" }}
            x="14.57"
            y="21.74"
            width="55.91"
            height="41.56"
          />
        </clipPath>
      </defs>
      <g style={{ clipPath: "url(#clippathProduct)" }}>
        <path
          style={{ fill: "#fff" }}
          d="m42.52,28.34h25.54c.1,0,.2,0,.3,0,.17.01.24-.06.24-.23,0-1.18.01-2.37-.01-3.55-.01-.55-.44-.92-.99-.94-.2,0-.39,0-.59,0-16.25,0-32.49,0-48.74,0-.23,0-.47,0-.7,0-.74.01-1.12.39-1.12,1.14,0,1.05,0,2.1,0,3.15q0,.43.44.44h25.62m0,33.09h25.57c.1,0,.21.02.29,0,.08-.03.17-.11.2-.19.03-.07,0-.18,0-.26v-30.36c0-.37,0-.38-.37-.38H16.82c-.37,0-.37,0-.37.38,0,10.01,0,20.02,0,30.03,0,.18,0,.36,0,.54,0,.17.07.25.24.25.1,0,.2,0,.3,0h25.54m0,1.87H15.74c-.85,0-1.17-.32-1.17-1.17,0-12.44,0-24.88-.01-37.32,0-1.62,1.03-2.72,2.24-3,.22-.05.44-.07.66-.07,16.71,0,33.41,0,50.12,0,1.59,0,2.83,1.21,2.89,2.8.01.36,0,.72,0,1.08v36.19c0,.13,0,.25,0,.38,0,.77-.35,1.12-1.12,1.12h-26.83"
        />
        <path
          style={{ fill: "#fff" }}
          d="m28.7,39.79c0,.53,0,1.06,0,1.58,0,.22.07.3.3.29.74-.01,1.49,0,2.23,0q.55,0,.55-.54c0-.94,0-1.88,0-2.82,0-.71-.49-1.19-1.2-1.2-.23,0-.47,0-.7,0-.66.01-1.15.5-1.16,1.16,0,.51,0,1.02,0,1.53m1.52,14.3h6.1c.34,0,.36,0,.29-.35-.35-1.91-.7-3.82-1.05-5.74-.25-1.36-.49-2.71-.73-4.07-.07-.39-.13-.43-.53-.41-.1,0-.2-.01-.29-.01-1.47,0-2.95.01-4.42.01-1.19,0-2.38,0-3.57,0-.2,0-.3.05-.34.27-.22,1.28-.46,2.56-.7,3.83-.37,2.03-.75,4.05-1.12,6.08-.07.37-.06.38.31.38,2.02,0,4.03,0,6.05,0m0,1.87h-7.39c-.84,0-1.22-.44-1.06-1.27.45-2.48.91-4.97,1.37-7.45.29-1.56.57-3.12.86-4.68.12-.63.44-.89,1.07-.89.47,0,.93,0,1.4,0,.35,0,.35,0,.35-.37,0-.97,0-1.93,0-2.9,0-1.88,1.31-3.17,3.18-3.18.67,0,1.33,0,1.94.32,1.08.56,1.66,1.45,1.7,2.67.03,1.05.01,2.1,0,3.15,0,.25.08.33.32.32.48-.01.97,0,1.45,0,.62,0,.97.31,1.07.91.16.92.33,1.85.49,2.77.36,1.95.72,3.89,1.07,5.84.22,1.17.43,2.34.64,3.51.15.81-.24,1.26-1.05,1.26-2.47,0-4.95,0-7.42,0"
        />
        <path
          style={{ fill: "#fff" }}
          d="m54.98,53.15c-2.43,0-4.85,0-7.28,0-.89,0-1.51.79-1.33,1.66.14.64.69,1.06,1.4,1.06,4.79,0,9.59,0,14.38,0,.06,0,.13,0,.19,0,.74-.05,1.28-.64,1.28-1.37,0-.77-.58-1.34-1.38-1.35-2.42,0-4.84,0-7.26,0m-.03,4.6c-2.38,0-4.77,0-7.15,0-1.63,0-2.89-.99-3.27-2.57-.4-1.67.73-3.46,2.43-3.83.29-.06.58-.1.88-.1,4.76,0,9.51,0,14.27,0,1.57,0,2.8.87,3.25,2.29.66,2.08-.9,4.2-3.13,4.21-2.43.01-4.86,0-7.28,0h0Z"
        />
        <path
          style={{ fill: "#fff" }}
          d="m54.38,36.67c2.97,0,5.93,0,8.9,0,.59,0,1.01.41,1,.96,0,.49-.38.89-.88.91-.27.02-.54,0-.81,0-5.68,0-11.36,0-17.04,0-.38,0-.72-.08-.94-.42-.41-.63,0-1.42.76-1.47.18-.01.36,0,.54,0h8.47Z"
        />
        <path
          style={{ fill: "#fff" }}
          d="m53.11,42.61c-1.78,0-3.56,0-5.34,0-.77,0-1.54-.02-2.3.02-.51.03-1.03-.48-1.01-.96.01-.51.43-.92.99-.92,5.13,0,10.26,0,15.39,0,.58,0,.99.39.99.94s-.41.93-1,.93c-2.57,0-5.14,0-7.71,0h0Z"
        />
        <path
          style={{ fill: "#fff" }}
          d="m50.86,46.7c-1.8,0-3.6,0-5.4,0-.61,0-1.02-.42-1-.98.03-.51.42-.88.96-.88,1.24,0,2.47,0,3.71,0,2.39,0,4.78,0,7.17,0,.71,0,1.17.6.94,1.24-.14.4-.48.62-.99.62-1.42,0-2.85,0-4.27,0h-1.13Z"
        />
        <path
          style={{ fill: "#fff" }}
          d="m51.32,26.92c-.53,0-1.06,0-1.59,0-.55,0-.96-.39-.98-.9-.02-.53.37-.96.94-.97,1.11-.02,2.22-.02,3.33,0,.54,0,.91.42.91.94,0,.53-.39.92-.94.93-.56.01-1.11,0-1.67,0h0Z"
        />
        <path
          style={{ fill: "#fff" }}
          d="m64.55,26.92c-.52,0-1.04,0-1.56,0-.61,0-1.01-.39-1.01-.95,0-.54.4-.92,1.01-.93,1.07,0,2.13-.01,3.2,0,.74.01,1.18.68.88,1.32-.16.36-.46.54-.85.55-.56,0-1.11,0-1.67,0"
        />
        <path
          style={{ fill: "#fff" }}
          d="m57.96,26.92c-.55,0-1.09,0-1.64,0-.55,0-.95-.4-.95-.92,0-.53.38-.94.92-.95,1.11-.01,2.22-.01,3.33,0,.54,0,.93.42.93.95,0,.52-.41.91-.95.92-.28,0-.56,0-.83,0h-.8Z"
        />
      </g>
    </svg>
  );
};

export const ARShowcaseDeployment = () => {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 85.04 85.04"
    >
      <defs>
        <clipPath id="clippathAR">
          <rect
            style={{ fill: "none" }}
            x="15.21"
            y="17.95"
            width="54.62"
            height="49.13"
          />
        </clipPath>
      </defs>
      <g style={{ clipPath: "url(#clippathAR)" }}>
        <path
          style={{ fill: "#fff" }}
          d="m42.52,19.71h-7.5c-.08,0-.17-.02-.24,0-.06.02-.13.09-.14.15-.12.65.31,1.18.98,1.18,4.6,0,9.21,0,13.81,0,.59,0,.97-.39.98-.98q0-.36-.37-.36h-7.53m24.3,23.84s0-.06,0-.08c-3.13-1.51-6.26-3.02-9.43-4.54v9.17c3.17-1.53,6.29-3.03,9.42-4.54m-39.19,4.54v-9.16c-3.17,1.53-6.3,3.04-9.43,4.55,0,.03,0,.05.01.08,3.12,1.51,6.25,3.01,9.42,4.54m1.79,2.83v.41c0,3.63,0,7.26,0,10.89,0,1.83,1.25,3.1,3.08,3.11,6.68,0,13.35,0,20.03,0,1.81,0,3.07-1.28,3.07-3.09,0-3.64,0-7.28,0-10.91,0-.11-.01-.22-.02-.38-.17.08-.31.13-.44.19-4.04,1.94-8.07,3.89-12.11,5.84-.36.18-.69.17-1.06,0-3.65-1.77-7.31-3.53-10.97-5.29-.51-.24-1.01-.48-1.59-.76m0-15.3c0,4.15.02,8.3-.02,12.45,0,.7.21,1.01.83,1.3,4.03,1.9,8.03,3.85,12.04,5.79.17.08.3.08.47,0,4.19-2.02,8.37-4.04,12.56-6.05.22-.11.3-.23.3-.48,0-8.61,0-17.23,0-25.84,0-1.79-1.27-3.06-3.06-3.07q-.37,0-.38.38c-.02,1.57-1.17,2.71-2.74,2.71-4.62,0-9.25,0-13.87,0-.17,0-.34,0-.5-.04-1.34-.28-2.18-1.32-2.19-2.72,0-.25-.07-.34-.33-.33-1.85,0-3.12,1.27-3.12,3.13,0,4.26,0,8.53,0,12.79m13.11-17.67c3.36,0,6.71,0,10.07,0,2.68,0,4.77,2.09,4.77,4.76,0,4.63,0,9.27,0,13.9,0,.26.08.39.31.5,3.85,1.85,7.7,3.7,11.54,5.56.35.17.59.42.6.83,0,.42-.22.68-.59.86-3.82,1.84-7.64,3.69-11.47,5.52-.3.14-.4.3-.4.63.01,3.93,0,7.86,0,11.79,0,2.72-2.08,4.8-4.81,4.8-6.7,0-13.41,0-20.11,0-2.71,0-4.79-2.08-4.79-4.78,0-3.94,0-7.88,0-11.81,0-.32-.1-.47-.39-.61-3.81-1.82-7.62-3.66-11.42-5.5-.56-.27-.8-.71-.58-1.18.1-.2.29-.41.5-.51,2.84-1.39,5.69-2.75,8.54-4.13,1.02-.49,2.03-.98,3.05-1.46.22-.1.3-.23.3-.48,0-4.61,0-9.23,0-13.85,0-2.76,2.07-4.83,4.83-4.83h10.04"
        />
        <path
          style={{ fill: "#fff" }}
          d="m47.19,41.91h0c.5,0,1,0,1.5.01.16,0,.22-.04.22-.2,0-.54,0-1.07,0-1.61,0-.17-.06-.23-.23-.23-1,0-2.01,0-3.01,0-.16,0-.21.06-.21.22,0,.54,0,1.08,0,1.61,0,.14.04.21.2.21.51,0,1.02,0,1.53,0m-1.73,2.52c0,.73.01,1.39,0,2.05,0,.19-.05.41-.15.57-.18.34-.58.47-.96.38-.36-.09-.63-.41-.65-.81-.02-.4,0-.79,0-1.19,0-2.08,0-4.16,0-6.23,0-.79.31-1.1,1.11-1.09,1.32,0,2.64,0,3.96,0,1.16,0,1.92.76,1.92,1.92,0,.6,0,1.2,0,1.8-.01,1.09-.8,1.85-1.89,1.83-.41,0-.82,0-1.31,0,.09.11.12.17.18.21.87.66,1.74,1.31,2.62,1.96.44.33.54.87.24,1.27-.3.41-.85.47-1.29.14-1.13-.84-2.25-1.7-3.37-2.54-.11-.08-.22-.16-.39-.28"
        />
        <path
          style={{ fill: "#fff" }}
          d="m53.01,35.33c0,.73-.65,1.14-1.27.85-.5-.22-.99-.47-1.48-.71-2.49-1.2-4.98-2.4-7.47-3.6-.18-.09-.33-.09-.52,0-2.96,1.43-5.91,2.86-8.88,4.28-.5.24-.98.12-1.22-.29-.27-.47-.1-1.02.41-1.27,1.46-.71,2.93-1.42,4.4-2.12,1.68-.81,3.36-1.62,5.04-2.43.35-.17.67-.17,1.01,0,3.11,1.51,6.23,3.01,9.35,4.51.37.18.61.43.62.79"
        />
        <path
          style={{ fill: "#fff" }}
          d="m38.76,44.3c-.29-.85-.57-1.66-.86-2.48-.03,0-.05.01-.08.02-.28.81-.56,1.62-.85,2.46h1.78Zm-.88,1.77c-.43,0-.86,0-1.3,0-.16,0-.24.05-.29.2-.06.2-.13.4-.21.6-.18.48-.64.71-1.1.56-.47-.15-.72-.63-.56-1.12.24-.75.51-1.5.77-2.25.6-1.74,1.2-3.48,1.8-5.22.17-.49.46-.72.9-.72.42,0,.69.24.86.73.56,1.64,1.13,3.28,1.69,4.92.3.86.6,1.71.88,2.57.15.47-.1.93-.55,1.09-.45.15-.91-.06-1.11-.51-.08-.19-.15-.4-.21-.6-.05-.19-.14-.25-.34-.25-.41.01-.83,0-1.24,0"
        />
      </g>
    </svg>
  );
};
